// extracted by mini-css-extract-plugin
export default {"TaskName":"TaskNameRender_TaskName__2k8o4"};